import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
    name: 'isEmpty'
})

// Checked empty or not

export class IsEmptyPipe implements PipeTransform {

    transform(value: string, args?: any): any {

        var isEmpty = _.isEmpty(value);;
        return isEmpty
    }

}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/pipesFiles/isEmpty.pipe.ts